import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Paper from "@mui/material/Paper";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import GroupListItem from "./GroupListItem";
import { useGeotabClient } from "@/components/GeotabClientContext";
import { FAIRFLEET_SERVICES, groupPages } from "@/constants/groupConfig";
import { useAddOrUpdateGroup } from "@/hooks/groups/useAddOrUpdateGroup";
import { useGroupByName } from "@/hooks/groups/useGroupByName";

const TABLE_MIN_HEIGHT = 200;

export function GroupLicenseManager() {
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const { mutateAsync: createOrUpdateGroup } = useAddOrUpdateGroup();
  const { geotabClient } = useGeotabClient();
  const { data: parentGroup, isLoading: parentLoading } = useGroupByName(FAIRFLEET_SERVICES);

  const pages = groupPages().filter(g => g.groupName !== "");

  return (
    <Box>
      {errorMessage && (
        <Alert severity="error" onClose={() => setErrorMessage(null)} sx={{ mb: 2 }}>
          {errorMessage}
        </Alert>
      )}

      <Paper variant="outlined" sx={{ minHeight: TABLE_MIN_HEIGHT }}>
        {parentLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: TABLE_MIN_HEIGHT }}>
            <CircularProgress />
          </Box>
        ) : (
          <List disablePadding>
            <ListItem divider>
              <ListItemText
                primary={FAIRFLEET_SERVICES}
                secondary={
                  parentGroup
                    ? t("admin.licenses.parentExists")
                    : t("admin.licenses.parentMissing")
                }
              />
              <Button
                variant="contained"
                size="small"
                disabled={!!parentGroup}
                onClick={async () => {
                  await createOrUpdateGroup({
                    geotabClient,
                    name: FAIRFLEET_SERVICES,
                    comment: "",
                    method: "Add",
                    parentId: "GroupCompanyId",
                  });
                }}
              >
                {parentGroup
                  ? t("admin.licenses.exists")
                  : t("admin.licenses.create")}
              </Button>
            </ListItem>

            {pages.map(group => (
              <GroupListItem key={group.name} groupConfig={group} setErrorMessage={setErrorMessage} />
            ))}
          </List>
        )}
      </Paper>
    </Box>
  );
}
